import React from "react"
import MangaList from "../Manga/MangaList"
import Context from "../context"
import AddManga from "../Manga/AddManga"
import { useEffect } from "react"
import Loader from "../Loader"
import Modal from "../Modal/Modal"

function Home () {

  // let mangas1 = [
  //     {mal_id: 423, url: 'https://myanimelist.net/character/423/Casca', image_url: 'https://cdn.myanimelist.net/images/characters/14/72697.jpg?s=507f381ee6e54d4bd2c59e6ed3b72c52', name: 'Casca', role: 'Main'},
  //     {mal_id: 7857, url: 'https://myanimelist.net/character/7857/Farnese_de_Vandimion', image_url: 'https://cdn.myanimelist.net/images/characters/3/150707.jpg?s=f4c441ed0f987e1ac4bd66e2a451db48', name: 'de Vandimion, Farnese', role: 'Main'},
  //     {mal_id: 424, url: 'https://myanimelist.net/character/424/Griffith', image_url: 'https://cdn.myanimelist.net/images/characters/9/326322.jpg?s=cccaa0f72e426492f92db8f04a168a20', name: 'Griffith', role: 'Main'},
  //     {mal_id: 422, url: 'https://myanimelist.net/character/422/Guts', image_url: 'https://cdn.myanimelist.net/images/characters/9/347984.jpg?s=79dbd77b8aaf7de0d3eb78ee62ef50e9', name: 'Guts', role: 'Main'},
  //     {mal_id: 7859, url: 'https://myanimelist.net/character/7859/Isidro', image_url: 'https://cdn.myanimelist.net/images/characters/9/101956.jpg?s=12a149f0da80d6597a0448867d524b3a', name: 'Isidro', role: 'Main'},
  //     {mal_id: 5060, url: 'https://myanimelist.net/character/5060/Puck', image_url: 'https://cdn.myanimelist.net/images/characters/8/101984.jpg?s=de3bc651dc8d49171f0d2f75fca2e7a0', name: 'Puck', role: 'Main'}
  // ]
  // mangas1 = mangas1.map(manga => manga = { ...manga, selected: false})
  // console.log(mangas1)
  
  const [mangas, setMangas] = React.useState([])
  const [loading, setLoading] = React.useState(true)

  useEffect ( () => {
    fetch("https://jikan1.p.rapidapi.com/manga/2/characters", {
      "method": "GET",
      "headers": {
        "x-rapidapi-host": "jikan1.p.rapidapi.com",
        "x-rapidapi-key": "df770bccf6msh69d58a8918ff753p1eb56cjsn01e28b03d25b"
      }
    })
      .then(response => response.json())
      .then(characters => {
        console.log(characters.characters)
        setTimeout( () => {
          let mangas1 = characters.characters
          mangas1 = mangas1.map(manga => manga = { ...manga, selected: false})
          setMangas(mangas1)
          setLoading(false)
        }, 2000)
      })
  }, [])
     
  function toggleManga(id) {
    setMangas(mangas.map(manga => {
        if (manga.mal_id === id) {
          manga.selected = !manga.selected
        }
        return manga
      })
    )
  }

  function removeManga(id) {
    setMangas(mangas.filter(manga => manga.mal_id !== id))
  }

  function addManga(name) {
    setMangas(mangas.concat([
      {
        name, 
        role: 'Main',
        url: null,
        image_url: null,
        mal_id: Date.now(),
        selected: false
      }
    ]))
  }
    return (
    <Context.Provider value={{ removeManga }}>
      <div className="wrapper">
        <Modal />
        <h1>Mangas characters API</h1>
        <p>(API: https://jikan1.p.rapidapi.com/manga/)</p>

        <React.Suspense fallback={<Loader />}>
          <AddManga onCreate={addManga} />
        </React.Suspense>

        {loading && <Loader />} 
        {mangas.length ? (
          <MangaList mangas={mangas} onToggle={toggleManga}/>
        ) : (
          loading ? null : (
            <p>No characters in database ! </p>
          )
        )}
      </div>
    </Context.Provider>
    )
  }
  
  export default Home